<template>
  <div class="container">
    <h2>基本设置</h2>
    <a-row gap="12">
      <a-form-model ref="formRef" layout="inline" :model="form" :rules="rules">
        <a-col :span="24">
          <a-form-model-item label="模板名称" prop="name">
            <a-input v-model="form.name" placeholder="不超过20个字符" showCount :maxLength="20" style="width: 280px">
              <span slot="suffix" class="input-suffix">
                {{ String(form.name || '').length + '/' + 20 }}
              </span>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="模板类型" prop="templateType">
            <a-select v-model="form.templateType" style="width: 280px" placeholder="请选择模板简介">
              <a-select-option :value="1">创新人才模版</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="模板简介" prop="description">
            <div class="textarea-suffix">
              <a-textarea class="textarea" v-model="form.description" placeholder="请输入内容" :maxLength="50" style="width: 280px"> </a-textarea>
              <span class="input-suffix">
                {{ String(form.description || '').length + '/' + 50 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="备注">
            <div class="textarea-suffix">
              <a-textarea class="textarea" v-model="form.remark" :rows="5" placeholder="请输入内容" :maxLength="200" style="width: 280px" />
              <span class="input-suffix">
                {{ String(form.remark || '').length + '/' + 200 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
      </a-form-model>
    </a-row>
    <a-row class="submit-footer">
      <a-button type="primary" @click="submit">保存</a-button>
    </a-row>
  </div>
</template>
<script>
export default {
  name: '',
  inject: ['getTemp', 'setTemp', 'getTempId', 'setTempId'],
  data() {
    return {
      form: {
        name: undefined,
        description: '',
        templateType: undefined,
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        templateType: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        description: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
    }
  },
  created() {
    const record = this.getTemp()
    if (record.id) {
      this.form.name = record.name
      this.form.description = record.description
      this.form.templateType = +record.templateType
      this.form.remark = record.remark
    }
  },
  methods: {
    async submit() {
      await this.$refs['formRef'].validate()
      const params = {
        ...this.form,
      }
      const tId = this.getTempId()
      if (tId) {
        params.id = tId
      }
      const { data } = await (tId ? this.$http.GroupReportTemp.editReportTemplate(params) : this.$http.GroupReportTemp.addReportTemplate(params))
      this.$message.success('操作成功')
      if (data) {
        this.setTempId(data)
        this.setTemp({ ...params, id: data })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  padding: 16px;
  .input-suffix {
    color: #999;
  }
  .textarea-suffix {
    position: relative;
    .textarea {
      padding-bottom: 20px;
    }
    .input-suffix {
      position: absolute;
      right: 10px;
      bottom: -2px;
    }
  }
  ::v-deep .ant-form-item {
    margin-bottom: 16px;
    .ant-form-item-label {
      width: 100px;
    }
  }
  .submit-footer {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
}
</style>
